import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { SelectionItem } from '../../../core/component/select/select.component';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { ConnectedCustomProperty } from '../../model/connected-custom-property';
import { CustomPropertyDataType } from '../../model/const/enums';
import { CustomProperty } from '../../model/custom-property';
import { ObjectComponent } from '../../model/object-component';

@Component({
    selector: 'app-object-component-property',
    templateUrl: './object-component-property.component.html',
    styleUrls: ['./object-component-property.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ObjectComponentPropertiesComponent implements OnInit, OnDestroy {
  constructor(
    private _cf: FormControlExFactory,
    private _fb: FormBuilder
  ) {}

  private _forms: FormArray;
  @Input() set forms(value: AbstractControl) {
    this._forms = value as FormArray;
  }
  get forms(): FormArray {
    return this._forms;
  }
  @Input() rootForm: FormGroup;
  @Input() property: ConnectedCustomProperty;
  @Input() component: ObjectComponent;
  private _subscription = new Subscription();
  form: FormGroup;

  ngOnDestroy(): void {
    if (this._subscription) this._subscription.unsubscribe();
  }

  ngOnInit(): void {
    this.selectionItems = this.property.property.selectableValues
      ? this.property.property.selectableValues.split('\n').map(v => new SelectionItem(v, v))
      : [];
    this.isRequired = this.property.mandatory;
    this.form = this.createPropertyValueForm(this.property);
    this.forms.controls.push(this.form);
  }

  get showNumeric(): boolean {
    return this.property.property.dataType === CustomPropertyDataType.Numeric && this.property.property.decimalCount > 0;
  }
  get showText(): boolean {
    return this.property.property.dataType === CustomPropertyDataType.Text;
  }
  get showInt(): boolean {
    return this.property.property.dataType === CustomPropertyDataType.Numeric && this.property.property.decimalCount === 0;
  }
  get showSelection(): boolean {
    return this.property.property.dataType === CustomPropertyDataType.Selection;
  }
  get showDate(): boolean {
    return this.property.property.dataType === CustomPropertyDataType.Date;
  }
  get showBoolean(): boolean {
    return this.property.property.dataType === CustomPropertyDataType.Boolean;
  }
  isRequired: boolean;

  selectionItems: SelectionItem[];

  private createPropertyValueForm(property: ConnectedCustomProperty): FormGroup {
    const value = this.component.customPropertyValues.find(v => this.getPropertyTypeId(v.customProperty) === property.property.id);
    const options = { required: property.mandatory };
    let group = this._fb.group({
      customProperty: this._cf.createHidden(property.property.id),
      dataType: this._cf.createHidden(property.property.dataType),
      boolValue: this._cf.createWithOptions(property.property.caption, value ? value.boolValue : false, options),
      numericValue: this._cf.createWithOptions(property.property.caption, value ? value.numericValue : undefined, options),
      dateValue: this._cf.createWithOptions(property.property.caption, value ? value.dateValue : undefined, options),
      textValue: this._cf.createWithOptions(property.property.caption, value ? value.textValue : undefined, options),
    });
    this._subscription.add(group.valueChanges.subscribe(x => this.rootForm.markAsDirty()));
    return group;
  }

  private getPropertyTypeId(type: string | CustomProperty) {
    if (typeof type !== 'string') return type.id;
    return type;
  }
}
